import axios from 'axios'
import CreateAddress from './dto/CreateAddress'
import {PagedAddressResultRequestDto} from './dto/PagedAddressResultRequestDto'
import GetAllAddresses from './dto/GetAllAddresses'
import UpdateAddress from './dto/UpdateAddress'
import GetAddress from './dto/GetAddress'
import { EntityDto } from '../../../../services/dto/entityDto'
import { PagedResultDto } from '../../../../services/dto/pagedResultDto'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Address/Create`
export const URL_DELETE = `${API_URL}/Address/Delete`
export const URL_GET = `${API_URL}/Address/Get`
export const URL_GET_ALL = `${API_URL}/Address/GetPagedAll`
export const URL_UPDATE = `${API_URL}/Address/Update`
export const URL_GET_BY_USER_ID = `${API_URL}/Address/GetByUserId`
export const URL_GET_BY_GRADUATE_ID = `${API_URL}/Address/GetByGraduateId`
export const URL_GET_ALL_OF_USER = `${API_URL}/Address/GetListByUserSelf`

export function onCreateAddress(createAddress: CreateAddress): Promise<boolean> {
  return axios.post(URL_CREATE, createAddress)
}

export function onDeleteAddress(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetAddressesAllOfTheUser(): Promise<GetAddress> {
  return axios.get(URL_GET_ALL_OF_USER)
}

export function onGetAddressesByUserId(user: EntityDto): Promise<GetAddress> {
  return axios.get(URL_GET_BY_USER_ID, {params: user})
}

export function onGetAddressesByGraduateId(grad: EntityDto): Promise<GetAddress> {
  return axios.get(URL_GET_BY_GRADUATE_ID, {params: grad})
}

export function onGetAddress(entityDto: EntityDto): Promise<GetAddress> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllAddresses(
  pagedFilterAndSortedRequest: PagedAddressResultRequestDto
): Promise<PagedResultDto<GetAllAddresses>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

